(function() {
    
    angular 
        .module('ngmvac')
        .directive('loadError', LoadErrorDirective);

    function LoadErrorDirective() {
        return {
            restrict: 'A',
            scope: {
                onLoadError: '&',
                errorIndex: '<'
            },
            link: function (scope, element, attrs) {
                element.on('error', function () {
                    scope.onLoadError({$event: {index: scope.errorIndex}});
                });
            }
        }
    }

})();